import errorReporter from '@app/errorReporter';

// This must be used on a ng-form component with ng-submit attributes properly set
// If you are not using ng-submit then you have to call $setSubmitted on the form
// to allow this directive to do its job.

angular.module('bb.util').directive('confirmOnExit', () => {
  return {
    require: '^form',
    restrict: 'A',
    link: (scope, element, _attrs, form) => {
      if (!form) {
        errorReporter.error(`confirm on exit is not properly configured for ${form.name}.
                                    make sure this directive is on a form and that the name parameter is properly set`);
        return;
      }

      const unsavedChangesMessage = 'LEAVE WITHOUT SAVING CHANGES?';

      // ng-router uses this event to say a rout change is going to happen
      scope.$on('$locationChangeStart', event => {
        if (
          (!form.$submitted && form.$dirty) ||
          (form.$submitted && !form.$valid)
        ) {
          if (!confirm(unsavedChangesMessage)) {
            event.preventDefault();
          }
        }
      });

      /*
                This can be used to capture the refresh event if we decide to go this
                route in the future then we can figure out a way to uncomment this

                As is, the code below works but it is global i.e. if there are two
                forms on the page then the onbefore reload event is removed for one
                of them resulting in strange behaviour.


                // prevents the event from propagating if the user
                // onbeforeunload is the refresh event on the page
                // if there is already one there this might mess up.
                if(window.onbeforeunload) {
                    console.error(`There are multiple on before unload events,
                                   the listener on ${form.name} may not work correctly`)
                }

                window.onbeforeunload = (event) => {
                    if((!form.$submitted && form.$dirty) || (form.$submitted && !form.$valid)) {
                        event.returnValue = unsavedChangesMessage;
                        return unsavedChangesMessage
                    }
                }

                // remove event listeners when the element is destroyed
                element.on('$destroy', () => {
                    window.onbeforeunload = null;
                });
                */
    },
  };
});
